import { json, type LoaderFunctionArgs, type MetaFunction } from "@remix-run/node";
import { Outlet } from "@remix-run/react";
import { getUserFrontId } from "~/utils/auth.server.ts";
import { prisma } from "~/utils/db.server.ts";


export const meta: MetaFunction = () => {
  return [
    { title: "Book on Demand" },
    { name: "description", content: "Welcome to Book on Demand!" },
  ];
};

export async function loader({ request }: LoaderFunctionArgs) {
  const userId = await getUserFrontId(request)
  const user = userId ? await prisma.userFront.findUniqueOrThrow({
    select: {
      id: true,
      nome: true,
      cognome: true,
      username: true,
      email: true,
    },
    where: { id: userId },
  }) : null

  return json({ user })
}

export default function Index() {
  return <Outlet />
}


